import ResampleContract from '../contracts/ResampleContract.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import {RESAMPLE} from 'decentralized/transactions/contracts.js';
import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';

class Resample {
    constructor(web3) {
        this.web3 = web3;
        this.contract = new ResampleContract().getContract(web3);
    }

    newResample(sampleHash, title, tags, samplesUsed, guildId) {
        return;
        console.log('newResample(%s, %s, %s, %s, %s)', sampleHash, title, tags, samplesUsed);
        tags = tags.map(x => this.web3.utils.fromAscii(x));
        samplesUsed = samplesUsed.map(x => ipfsHashToBytes32(x));
        sampleHash = ipfsHashToBytes32(sampleHash);

        new EthereumTransaction(
            RESAMPLE,
            'newResample',
            [
                sampleHash,
                title,
                tags,
                samplesUsed,
                guildId
            ])
            .execute()
            .then(x => {
            });
    }
}

export default Resample;
